export const INVOICE_STATUS = {
  ALL: 'ORDERS.STATUS.ALL',
  INVOICED: 'ORDERS.STATUS.INVOICED',
  SHIPPED: 'ORDERS.STATUS.SHIPPED',
  DELIVERED: 'ORDERS.STATUS.DELIVERED',
  CANCELED: 'ORDERS.STATUS.CANCELED',
  PAID: 'ORDERS.STATUS.PAID',
  PARTIALLY_PAID: 'ORDERS.STATUS.PARTIALLY_PAID',
  TRANSFERRED: 'ORDERS.STATUS.TRANSFERRED',
};

export const INVOICE_STATUS_COLORS = {
  INVOICED: 'success',
  SHIPPED: 'success',
  DELIVERED: 'success',
  CANCELED: 'danger',
  PAID: 'success',
  PARTIALLY_PAID: 'warn',
  TRANSFERRED: 'warn',
};

export const INVOICE_LIST_FILTERS: IInvoiceFilters = {
  filteredField: '',
  genericTerm: '',
  date: [],
  productType: '',
  invoiceStatus: '',
};

export const INVOICE_PRODUCT_TYPE = {
  ALL: 'INVOICES.PRODUCT_TYPE.ALL',
  HARDWARE: 'INVOICES.PRODUCT_TYPE.HARDWARE',
  SOFTWARE_SERVICE_CLOUD: 'INVOICES.PRODUCT_TYPE.SOFTWARE_SERVICE_CLOUD',
};

export const INVOICE_FILTER_OPTIONS = {
  INVOICE_NUMBER: 'INVOICES.FILTER_OPTIONS.INVOICE_NUMBER',
  INVOICE_SERIE: 'INVOICES.FILTER_OPTIONS.INVOICE_SERIE',
  ORDER_NUMBER: 'INVOICES.FILTER_OPTIONS.ORDER_NUMBER',
  INVOICE_PART_NUMBER: 'INVOICES.FILTER_OPTIONS.INVOICE_PART_NUMBER',
};

export const INVOICE_STATUS_TOOLTIP = {
  PROCESSING: 'ORDERS.DETAILS.STATUS.PROCESSING',
  PROCESSED: 'ORDERS.DETAILS.STATUS.PROCESSED',
  INVOICED: 'ORDERS.DETAILS.STATUS.INVOICED',
  PARTIALLY_INVOICED: 'ORDERS.DETAILS.STATUS.PARTIALLY_INVOICED',
  SHIPPED: 'ORDERS.DETAILS.STATUS.SHIPPED',
  PARTIALLY_SHIPPED: 'ORDERS.DETAILS.STATUS.PARTIALLY_SHIPPED',
  CANCELED: 'ORDERS.DETAILS.STATUS.CANCELED',
  PARTIALLY_CANCELED: 'ORDERS.DETAILS.STATUS.PARTIALLY_CANCELED',
  PAID: 'ORDERS.DETAILS.STATUS.PAID',
  PARTIALLY_PAID: 'ORDERS.DETAILS.STATUS.PARTIALLY_PAID',
  TRANSFERRED: 'ORDERS.DETAILS.STATUS.TRANSFERRED',
};
